import {
  FETCH_TRANSACTION_CHARGES_START,
  FETCH_TRANSACTION_CHARGES_SUCCESS,
  FETCH_TRANSACTION_CHARGES_ERROR,
  FETCH_PROCESSING_FEE_TEST_CLEAR,
  ADD_TRANSACTION_CHARGE_START,
  ADD_TRANSACTION_CHARGE_SUCCESS,
  ADD_TRANSACTION_CHARGE_ERROR,
  DELETE_TRANSACTION_CHARGE_START,
  DELETE_TRANSACTION_CHARGE_ERROR,
  DELETE_TRANSACTION_CHARGE_SUCCESS,
  UPDATE_TRANSACTION_CHARGE_START,
  UPDATE_TRANSACTION_CHARGE_ERROR,
  UPDATE_TRANSACTION_CHARGE_SUCCESS,
  INDEX_PAGE_SIZE_DEFAULT,
} from '../../constants/ActionTypes';

const INIT_STATE = {
  data: [],
  meta: {
    page: 1,
    pageSize: INDEX_PAGE_SIZE_DEFAULT,
    pageTotal: 1,
  },
  loading: false,
  error: null,

  feesTest: {
    data: [],
    loading: false,
    error: null,
  },
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case ADD_TRANSACTION_CHARGE_START:
    case DELETE_TRANSACTION_CHARGE_START:
    case UPDATE_TRANSACTION_CHARGE_START:
    case FETCH_TRANSACTION_CHARGES_START: {
      return {
        ...state,
        loading: true,
      };
    }

    case FETCH_PROCESSING_FEE_TEST_CLEAR: {
      return {
        ...state,
        feesTest: {
          ...state.feesTest,
          data: [],
        },
      };
    }

    case ADD_TRANSACTION_CHARGE_ERROR:
    case DELETE_TRANSACTION_CHARGE_ERROR:
    case UPDATE_TRANSACTION_CHARGE_ERROR:
    case FETCH_TRANSACTION_CHARGES_ERROR: {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    }

    case FETCH_TRANSACTION_CHARGES_SUCCESS: {
      return {
        ...state,
        loading: false,
        data: action.payload,
        meta: { ...state.meta, ...action.meta },
      };
    }

    case ADD_TRANSACTION_CHARGE_SUCCESS: {
      const allCurrencies = state.data;
      allCurrencies.push(action.payload);
      return {
        ...state,
        loading: false,
        data: allCurrencies,
      };
    }

    case DELETE_TRANSACTION_CHARGE_SUCCESS: {
      const updatedData = state.data.filter(
        (transactionCharge) => transactionCharge._id !== action.payload,
      );
      return {
        ...state,
        loading: false,
        data: updatedData,
      };
    }

    case UPDATE_TRANSACTION_CHARGE_SUCCESS: {
      const updatedData = state.data.map(
        (transactionCharge) => (
          transactionCharge._id !== action.payload._id ? transactionCharge : action.payload
        ),
      );
      return {
        ...state,
        loading: false,
        data: updatedData,
      };
    }

    default:
      return state;
  }
};
